<template>
  <v-app>
    <v-main>
      <v-img class="image1-position" max-width="130px" :src="image1"></v-img>
      <v-img class="circle1-position" max-width="100px" :src="image2"></v-img>
      <AppBarPublic color="white" />
      <v-container class="app-width-limit mb-10">
        <LogisticsSection />
      </v-container>
      <v-main
        style="min-height: 100vh"
        class="background-gradient d-flex justify-center"
      >
        <v-container class="app-width-limit">
          <BenefitsSection class="mt-5" />
          <ColaboratosSection class="mt-16" />
        </v-container>
      </v-main>
      <section class="d-flex flex-column primary100">
        <v-container ref="login" class="my-0 py-0 fill-height">
          <LoginSection />
        </v-container>
        <Footer />
      </section>
    </v-main>
  </v-app>
</template>

<script>
import AppBarPublic from "@/components/public/AppBarPublic";
import Footer from "@/components/public/Footer";
import LogisticsSection from "./sections/LogisticsSection";
import BenefitsSection from "./sections/BenefitsSection";
import ColaboratosSection from "./sections/ColaboratorsSection";
import LoginSection from "./sections/LoginSection";
export default {
  components: {
    LogisticsSection,
    ColaboratosSection,
    BenefitsSection,
    LoginSection,
    AppBarPublic,
    Footer,
  },
  data: () => ({
    image1: require("@/assets/images/image-3.png"),
    image2: require("@/assets/images/large-circle.png"),
  }),
  created() {
    this.$root.$on("toLogin", () => this.scrollMeToLogin());
    if (this.$route.hash) this.scrollMeToLogin();
  },
  methods: {
    scrollMeToLogin() {
      this.$nextTick(() => {
        if (this.$refs.login) this.$refs.login.scrollIntoView();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.background-gradient {
  background: linear-gradient(
    0deg,
    rgba(220, 215, 245, 0) 0%,
    rgba(200, 193, 240, 0.169778) 26.56%,
    rgba(185, 176, 236, 0.3) 100%
  );
}
.image1-position {
  position: absolute;
  top: 20%;
  right: 1%;
  z-index: 0;
}
.image2-position {
  position: absolute;
  top: 294%;
  right: 10%;
  z-index: 0;
}
.circle1-position {
  position: absolute;
  right: 0%;
  top: 45%;
  z-index: 0;
}
.circle2-position {
  position: absolute;
  left: 0%;
  top: 220%;
  z-index: 0;
}

.logistics {
  height: 83vh;
  scroll-snap-align: center;
}
section {
  height: 100vh;
  scroll-snap-align: center;
}
.scroll-container {
  height: 100vh;
  overflow-y: scroll;
  scroll-snap-type: y mandatory;
}
</style>
